import { AxiosResponse } from "axios";

const downloadFileInBrowser = (file: File | Blob, filename: string) => {
  const url = window.URL.createObjectURL(file);
  const link = document.createElement("a");

  link.href = url;
  link.setAttribute("download", filename);

  document.body.appendChild(link);
  link.click();

  setTimeout(function () {
    link.remove();
    URL.revokeObjectURL(url);
  }, 50);
};

function getFilenameFromResponse({ response, defaultFilename }: { response: AxiosResponse<unknown>; defaultFilename: string }) {
  const disposition = response.headers["content-disposition"] as string | undefined;
  let filename = defaultFilename;

  if (disposition) {
    const utf8Match = disposition.match(/filename\*=UTF-8''(.+?)(;|$)/i);
    if (utf8Match?.[1]) {
      filename = decodeURIComponent(utf8Match[1]);
    } else {
      const fallbackMatch = disposition.match(/filename="?([^";]+)"?/i);
      if (fallbackMatch?.[1]) {
        filename = fallbackMatch[1];
      }
    }
  }

  return filename;
}

export const downloadFile = ({
  response,
  defaultFilename,
}: {
  response: AxiosResponse;
  defaultFilename: string;
}) => {
  const filename = getFilenameFromResponse({ response, defaultFilename });
  const type = response.headers["content-type"] as string;

  const file = new Blob([response.data], { type });
  downloadFileInBrowser(file, filename);
};
